<template>
  <div class="flex-container">
    <div class="flex-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/sys/merchant/merchantList' }">商户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/sys/merchant/merchantDetail/' + channelId + '/' + merchantId }">{{ merchantName }}</el-breadcrumb-item>
        <el-breadcrumb-item>门店列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-form :inline="true" size="mini" :model="searchForm" class="search-form">
      <el-form-item label="门店名称：">
        <el-input v-model="searchForm.storeName" clearable placeholder="请输入门店名称" style="width:170px;" />
      </el-form-item>
      <el-form-item label="门店编码：">
        <el-input v-model="searchForm.storeCode" clearable placeholder="请输入门店编码" style="width:150px;" />
      </el-form-item>
      <el-form-item label="地址：">
        <el-input v-model="searchForm.address" clearable placeholder="请输入地址" style="width:180px;" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="flex-item table-wrapper">
      <el-table :data="tableData" border size="small" style="width:100%;" v-loading="tableLoading" :height="tableHeight">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="storeCode" label="门店编码" width="120" align="center" />
        <el-table-column prop="storeName" label="门店名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip />
        <el-table-column prop="contact" label="联系人" width="80" align="center" />
        <el-table-column prop="phone" label="电话" width="120" align="center" />
        <el-table-column prop="area" label="面积(m²)" width="80" align="center" />
        <el-table-column label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === '1' ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="110" align="center" />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewStore(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-bar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <div class="form-footer-fixed">
      <el-button size="medium" @click="goBack"><i class="el-icon-back"></i> 返回商户详情</el-button>
      <span class="footer-hint">商户：{{ merchantName }}</span>
    </div>
  </div>
</template>

<script>
import { mockStores } from "../workflow/mockData";
import { mockMerchants } from "../workflow/mockData";

export default {
  name: "merchantStoreList",
  data() {
    return {
      channelId: '',
      merchantId: '',
      merchantName: '',
      allStores: [],
      tableData: [],
      tableLoading: false,
      tableHeight: '380px',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      totalStoreNum: 0,
      searchForm: { storeName: '', storeCode: '', address: '' },
    };
  },
  created() {
    this.channelId = this.$route.params.channelId || '';
    this.merchantId = this.$route.params.merchantId || '';
    const merchant = mockMerchants.find(m => m.merchantId === this.merchantId);
    this.merchantName = merchant ? merchant.merchantName : '未知商户';
    this.loadData();
    this.setTableHeight();
  },
  methods: {
    setTableHeight() {
      if (typeof window !== 'undefined') {
        this.tableHeight = Math.round((window.innerHeight || document.documentElement.clientHeight) * 0.55) + 'px';
      }
    },
    loadData() {
      this.tableLoading = true;
      setTimeout(() => {
        this.allStores = mockStores.filter(s => s.merchantId === this.merchantId);
        this.totalStoreNum = this.allStores.length;
        this.filterData();
        this.tableLoading = false;
      }, 200);
    },
    filterData() {
      let list = [...this.allStores];
      const sn = (this.searchForm.storeName || '').trim();
      const sc = (this.searchForm.storeCode || '').trim();
      const sa = (this.searchForm.address || '').trim();
      if (sn) list = list.filter(s => s.storeName.includes(sn));
      if (sc) list = list.filter(s => s.storeCode.includes(sc));
      if (sa) list = list.filter(s => s.address.includes(sa));
      this.total = list.length;
      const start = (this.currentPage - 1) * this.pageSize;
      this.tableData = list.slice(start, start + this.pageSize);
    },
    onSearch() { this.currentPage = 1; this.filterData(); },
    onReset() { this.searchForm = { storeName: '', storeCode: '', address: '' }; this.onSearch(); },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.filterData(); },
    handleCurrentChange(val) { this.currentPage = val; this.filterData(); },
    goBack() { this.$router.push('/sys/merchant/merchantDetail/' + this.channelId + '/' + this.merchantId); },
    viewStore(row) { this.$router.push('/sys/merchant/storeDetail/' + this.channelId + '/' + this.merchantId + '/' + row.storeId); },
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 12px; }
.header-stats { display: flex; align-items: center; gap: 20px; }
.stats-item { display: flex; align-items: center; }
.stats-num { font-size: 20px; font-weight: 700; color: #409EFF; line-height: 1.2; }
.stats-label { font-size: 12px; color: #909399; margin-left: 4px; }
.search-form { margin-bottom: 16px; }
.flex-item { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.table-wrapper { flex: 1; min-height: 0; overflow: hidden; }
.pagination-bar { text-align: right; padding: 8px 0; flex-shrink: 0; }
.form-footer-fixed {
  text-align: center; padding: 16px 0; border-top: 1px solid #ebeef5;
  background: #fff; flex-shrink: 0; position: relative; z-index: 10;
}
.form-footer-fixed .el-button { min-width: 140px; }
.footer-hint { margin-left: 20px; font-size: 13px; color: #909399; }
</style>
